import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BankOutlined,
  TeamOutlined,
  FileTextOutlined,
  ProfileOutlined,
  SolutionOutlined,
  ExperimentOutlined,
  CalendarOutlined,
  DollarOutlined,
  SearchOutlined,
  EyeOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

import { Input, Select } from "antd";

import "./quallyhireProductAnalytics.scss";
import superUseStatsStore from "../../../store/superuser.store";

export default function QuallyhireProductAnalytics() {
  const navigate = useNavigate();
  const { superUserInfo,superUserAnalytics} = superUseStatsStore();
  
  const [selectedProduct, setSelectedProduct] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [planFilter, setPlanFilter] = useState("ALL");

 
  // ==========================================================
  // PRODUCT ANALYTICS
  // Replace later with backend API response
  // ==========================================================

  const productAnalytics = {
    ALL: {
      companies: {
        total: superUserAnalytics?.overallstats?.companies,
        active: 98,
      },

      users: {
        total: superUserAnalytics?.overallstats?.users,
        active: 521,
      },

      jobs: {
        total: superUserAnalytics?.overallstats?.jobs,
        active: 682,
      },

      applications: {
        total: superUserAnalytics?.overallstats?.applications,
        thisMonth: 2680,
      },

      resumes: {
        total: superUserAnalytics?.overallstats?.resumes,
        thisMonth: 3210,
      },
      revenue: {
        total: 0,
        thisMonth: 0,
      },
    },

    QHRFLOW: {
      companies: {
        total: superUserAnalytics?.qhrflowstats?.companies,
        active: 71,
      },

      users: {
        total: superUserAnalytics?.qhrflowstats?.users,
        active: 410,
      },

      jobs: {
        total: superUserAnalytics?.qhrflowstats?.jobs,
        active: 412,
      },

      resumes: {
        total: superUserAnalytics?.qhrflowstats?.resumes,
        thisMonth: 3210,
      },

      applications: {
        total: superUserAnalytics?.qhrflowstats?.applications,
        thisMonth: 1840,
      },

      evaluations: {
        total: superUserAnalytics?.qhrflowstats?.evaluations,
        thisMonth: 420,
      },

      interviews: {
        total: 0,
        thisMonth: 186,
      },

      revenue: {
        total: 0,
        thisMonth: 0,
      },
    },

    NUJOBS: {
      companies: {
        total: superUserAnalytics?.nujobsstats?.companies,
        active: 52,
      },

      users: {
        total: superUserAnalytics?.nujobsstats?.users,
        active: 111,
      },

      nujusers: {
        total: superUserAnalytics?.nujobsstats?.nujusers,
        active: 111,
      },
      
      jobs: {
        total: superUserAnalytics?.nujobsstats?.jobs,
        active: 270,
      },

      applications: {
        total: superUserAnalytics?.nujobsstats?.applications,
        thisMonth: 840,
      },

      revenue: {
        total: 0,
        thisMonth: 0,
      },
    },
  };

  // ==========================================================
  // COMPANY DATA
  //
  // Each company can have:
  // QHRFlow subscription
  // NuJobs subscription
  // Both
  // ==========================================================

  const companies = [
    {
      qhoid: "QHO001",

      companyName: "ABC Technologies Pvt Ltd",

      superAdminName: "Rahul Sharma",

      city: "Bangalore",
      country: "India",

      users: 12,

      subscriptions: {
        QHRFLOW: {
          subscribed: true,

          planName: "Growth",

          status: "ACTIVE",

          users: 8,

          jobs: 42,

          resumes: 3450,

          applications: 1280,

          evaluations: 320,

          revenue: 48000,
        },

        NUJOBS: {
          subscribed: true,

          planName: "Business",

          status: "ACTIVE",

          users: 4,

          jobs: 18,

          applications: 420,

          revenue: 20000,
        },
      },
    },

    {
      qhoid: "QHO002",

      companyName: "XYZ Systems",

      superAdminName: "Priya Singh",

      city: "Pune",
      country: "India",

      users: 3,

      subscriptions: {
        QHRFLOW: {
          subscribed: true,

          planName: "Starter",

          status: "ACTIVE",

          users: 3,

          jobs: 14,

          resumes: 820,

          applications: 310,

          evaluations: 70,

          revenue: 12000,
        },

        NUJOBS: {
          subscribed: false,
        },
      },
    },

    {
      qhoid: "QHO003",

      companyName: "PQR Solutions",

      superAdminName: "Amit Patil",

      city: "Nashik",
      country: "India",

      users: 2,

      subscriptions: {
        QHRFLOW: {
          subscribed: false,
        },

        NUJOBS: {
          subscribed: true,

          planName: "Growth",

          status: "TRIAL",

          users: 2,

          jobs: 22,

          applications: 180,

          revenue: 0,
        },
      },
    },
  ];

  // ==========================================================
  // FORMAT
  // ==========================================================

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-IN").format(number || 0);
  };

  const formatCurrency = (number) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(number || 0);
  };

  // ==========================================================
  // STATUS
  // ==========================================================

  const getStatusClass = (status) => {
    if (!status) {
      return "neutral";
    }

    if (status === "ACTIVE") {
      return "success";
    }

    if (status === "TRIAL") {
      return "warning";
    }

    if (
      status === "INACTIVE" ||
      status === "EXPIRED"
    ) {
      return "danger";
    }

    return "neutral";
  };

  // ==========================================================
  // TOTAL COMPANY REVENUE
  // ==========================================================

  const getCompanyRevenue = (company) => {
    let total = 0;

    if (company.subscriptions.QHRFLOW?.subscribed) {
      total +=
        company.subscriptions.QHRFLOW.revenue || 0;
    }

    if (company.subscriptions.NUJOBS?.subscribed) {
      total +=
        company.subscriptions.NUJOBS.revenue || 0;
    }

    return total;
  };

    const statsData = superUserInfo?.stats?.map((comp, idx) => {
        return {
            select:"",
            id: idx+1,
            name: comp?.companyname,
            jds:  comp?.totaljds,
            resumes: comp?.totalresumes,
            users: comp?.totalusers,
            vendors:  comp?.totalvendors,
            customers: comp?.totalcustomers,
        };
  }); 

  // ==========================================================
  // FILTER COMPANIES
  // ==========================================================

  const filteredCompanies = superUserAnalytics?.companyarray?.filter((company) => {
    const search = searchText.toLowerCase();

    const matchesSearch =
      company.companyName
        .toLowerCase()
        .includes(search) ||
      company.superAdminName
        .toLowerCase()
        .includes(search) ||
      company.qhoid
        .toLowerCase()
        .includes(search);

    // PRODUCT FILTER

    let matchesProduct = true;

    if (selectedProduct !== "ALL") {
      matchesProduct =
        company.subscriptions[selectedProduct]?.subscribed;
    }

    // STATUS FILTER

    let matchesStatus = true;

    if (
      selectedProduct !== "ALL" &&
      statusFilter !== "ALL"
    ) {
      matchesStatus =
        company.subscriptions[selectedProduct]?.status ===
        statusFilter;
    }

    // PLAN FILTER

    let matchesPlan = true;

    if (
      selectedProduct !== "ALL" &&
      planFilter !== "ALL"
    ) {
      matchesPlan =
        company.subscriptions[selectedProduct]?.planName ===
        planFilter;
    }

    return (
      matchesSearch &&
      matchesProduct &&
      matchesStatus &&
      matchesPlan
    );
  });

  // ==========================================================
  // CHANGE PRODUCT
  // ==========================================================

  const handleProductChange = (product) => {
    setSelectedProduct(product);

    // Reset product-specific filters

    setStatusFilter("ALL");
    setPlanFilter("ALL");
  };

  // ==========================================================
  // VIEW COMPANY
  // ==========================================================

  const handleViewAnalytics = (company) => {
    navigate(
      `/companyanalytics/${company.qhoid}`
    );
  };

  // ==========================================================
  // KPI CARD
  // ==========================================================

  const StatCard = ({
    icon,
    title,
    value,
    subValue,
  }) => {
    return (
      <div className="qhrProductAnalytics-stat-card">

        <div className="qhrProductAnalytics-stat-icon">
          {icon}
        </div>

        <div className="qhrProductAnalytics-stat-content">

          <div className="qhrProductAnalytics-stat-title">
            {title}
          </div>

          <div className="qhrProductAnalytics-stat-value">
            {value}
          </div>

          {subValue && (
            <div className="qhrProductAnalytics-stat-subvalue">
              {subValue}
            </div>
          )}

        </div>

      </div>
    );
  };

  // ==========================================================
  // PRODUCT PLAN
  // ==========================================================

  const ProductPlan = ({
    subscription,
    product,
  }) => {
    if (!subscription?.subscribed) {
      return (
        <span className="qhrProductAnalytics-not-subscribed">
          —
        </span>
      );
    }

    return (
      <div className="qhrProductAnalytics-product-plan">

        <div
          className={`qhrProductAnalytics-product-label ${product.toLowerCase()}`}
        >
          {product === "QHRFLOW"
            ? "QHRFlow"
            : "NuJobs"}
        </div>

        <div className="qhrProductAnalytics-plan-name">
          {subscription.planName}
        </div>

        <span
          className={`qhrProductAnalytics-status ${getStatusClass(
            subscription.status
          )}`}
        >
          {subscription.status}
        </span>

      </div>
    );
  };

  const currentAnalytics =
    productAnalytics[selectedProduct];

  return (
    <div className="qhrProductAnalytics-wrapper">

      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="qhrProductAnalytics-header">

        <div>

          <div className="qhrProductAnalytics-title">
            Product Analytics
          </div>

          <div className="qhrProductAnalytics-subtitle">
            QuallyHire product usage, customers and revenue
          </div>

        </div>

        <div className="qhrProductAnalytics-header-badge">
          Admin Analytics
        </div>

      </div>

      {/* =====================================================
          PRODUCT SELECTOR
      ====================================================== */}

      <div className="qhrProductAnalytics-product-tabs">

        <button
          className={
            selectedProduct === "ALL"
              ? "active"
              : ""
          }
          onClick={() =>
            handleProductChange("ALL")
          }
        >
          <AppstoreOutlined />

          All Products
        </button>

        <button
          className={
            selectedProduct === "QHRFLOW"
              ? "active"
              : ""
          }
          onClick={() =>
            handleProductChange("QHRFLOW")
          }
        >
          QHRFlow
        </button>

        <button
          className={
            selectedProduct === "NUJOBS"
              ? "active"
              : ""
          }
          onClick={() =>
            handleProductChange("NUJOBS")
          }
        >
          NuJobs
        </button>

      </div>

      {/* =====================================================
          KPI
      ====================================================== */}

      <div className="qhrProductAnalytics-stats-grid">

        <StatCard
          icon={<BankOutlined />}
          title="Companies"
          value={formatNumber(
            currentAnalytics.companies.total
          )}
          subValue={`${formatNumber(
            currentAnalytics.companies.active
          )} Active`}
        />

        <StatCard
          icon={<TeamOutlined />}
          title="Users"
          value={formatNumber(
            currentAnalytics.users.total
          )}
          subValue={`${formatNumber(
            currentAnalytics.users.active
          )} Active`}
        />

        <StatCard
          icon={<FileTextOutlined />}
          title="Jobs"
          value={formatNumber(
            currentAnalytics.jobs.total
          )}
          subValue={`${formatNumber(
            currentAnalytics.jobs.active
          )} Active`}
        />


          <StatCard
            icon={<ProfileOutlined />}
            title="Resumes"
            value={formatNumber(
              currentAnalytics.resumes?.total
            )}
            subValue={`+${formatNumber(
              currentAnalytics.resumes?.thisMonth
            )} This Month`}
          />


        <StatCard
          icon={<SolutionOutlined />}
          title="Applications"
          value={formatNumber(
            currentAnalytics.applications.total
          )}
          subValue={`+${formatNumber(
            currentAnalytics.applications.thisMonth
          )} This Month`}
        />

        {selectedProduct === "QHRFLOW" && (
          <>
            <StatCard
              icon={<ExperimentOutlined />}
              title="Evaluations"
              value={formatNumber(
                currentAnalytics.evaluations.total
              )}
              subValue={`+${formatNumber(
                currentAnalytics.evaluations.thisMonth
              )} This Month`}
            />

            <StatCard
              icon={<CalendarOutlined />}
              title="Interviews"
              value={formatNumber(
                currentAnalytics.interviews.total
              )}
              subValue={`+${formatNumber(
                currentAnalytics.interviews.thisMonth
              )} This Month`}
            />
          </>
        )}

        {selectedProduct === "NUJOBS" && (
          <>
            <StatCard
              icon={<ExperimentOutlined />}
              title="NuJobs Users (Candidates)"
              value={formatNumber(
                currentAnalytics.nujusers.total
              )}
              subValue={`+${formatNumber(
                currentAnalytics.nujusers.thisMonth
              )} This Month`}
            />
          </>
        )}

        <StatCard
          icon={<DollarOutlined />}
          title="Revenue"
          value={formatCurrency(
            currentAnalytics.revenue.total
          )}
          subValue={`${formatCurrency(
            currentAnalytics.revenue.thisMonth
          )} This Month`}
        />

      </div>

      {/* =====================================================
          PRODUCT BREAKDOWN - ALL PRODUCTS
      ====================================================== */}

      {selectedProduct === "ALL" && (

        <div className="qhrProductAnalytics-product-breakdown">

          {/* QHRFLOW */}

          <div className="qhrProductAnalytics-product-card">

            <div className="qhrProductAnalytics-product-card-header">

              <div>
                <div className="qhrProductAnalytics-product-card-title">
                  QHRFlow
                </div>

                <div className="qhrProductAnalytics-product-card-subtitle">
                  Recruitment & ATS Platform
                </div>
              </div>

              <button
                onClick={() =>
                  handleProductChange("QHRFLOW")
                }
              >
                View
              </button>

            </div>

            <div className="qhrProductAnalytics-product-metrics">

              <div>
                <span>Companies</span>
                <strong>
                  {formatNumber(
                    productAnalytics.QHRFLOW
                      .companies.total
                  )}
                </strong>
              </div>

              <div>
                <span>Users</span>
                <strong>
                  {formatNumber(
                    productAnalytics.QHRFLOW.users
                      .total
                  )}
                </strong>
              </div>

              <div>
                <span>Jobs</span>
                <strong>
                  {formatNumber(
                    productAnalytics.QHRFLOW.jobs
                      .total
                  )}
                </strong>
              </div>

              <div>
                <span>Resumes</span>
                <strong>
                  {formatNumber(
                    productAnalytics.QHRFLOW.resumes
                      .total
                  )}
                </strong>
              </div>

              <div>
                <span>Applications</span>
                <strong>
                  {formatNumber(
                    productAnalytics.QHRFLOW
                      .applications.total
                  )}
                </strong>
              </div>

              <div>
                <span>Revenue</span>
                <strong>
                  {formatCurrency(
                    productAnalytics.QHRFLOW.revenue
                      .total
                  )}
                </strong>
              </div>

            </div>

          </div>

          {/* NUJOBS */}

          <div className="qhrProductAnalytics-product-card">

            <div className="qhrProductAnalytics-product-card-header">

              <div>

                <div className="qhrProductAnalytics-product-card-title">
                  NuJobs
                </div>

                <div className="qhrProductAnalytics-product-card-subtitle">
                  Job Posting & Application Platform
                </div>

              </div>

              <button
                onClick={() =>
                  handleProductChange("NUJOBS")
                }
              >
                View
              </button>

            </div>

            <div className="qhrProductAnalytics-product-metrics">

              <div>
                <span>Companies</span>

                <strong>
                  {formatNumber(
                    productAnalytics.NUJOBS
                      .companies.total
                  )}
                </strong>
              </div>

              <div>
                <span>Users</span>

                <strong>
                  {formatNumber(
                    productAnalytics.NUJOBS.users
                      .total
                  )}
                </strong>
              </div>
              <div>
                <span>NUJ Users</span>

                <strong>
                  {formatNumber(
                    productAnalytics.NUJOBS.nujusers
                      .total
                  )}
                </strong>
              </div>
              <div>
                <span>Jobs</span>

                <strong>
                  {formatNumber(
                    productAnalytics.NUJOBS.jobs
                      .total
                  )}
                </strong>
              </div>

              <div>
                <span>Applications</span>

                <strong>
                  {formatNumber(
                    productAnalytics.NUJOBS
                      .applications.total
                  )}
                </strong>
              </div>

              <div>
                <span>Revenue</span>

                <strong>
                  {formatCurrency(
                    productAnalytics.NUJOBS.revenue
                      .total
                  )}
                </strong>
              </div>

            </div>

          </div>

        </div>

      )}

      {/* =====================================================
          COMPANY SECTION
      ====================================================== */}

      <div className="qhrProductAnalytics-company-section">

        <div className="qhrProductAnalytics-company-header">

          <div>

            <div className="qhrProductAnalytics-section-title">
              Companies
            </div>

            <div className="qhrProductAnalytics-company-count">
              {filteredCompanies?.length} companies
            </div>

          </div>

          <div className="qhrProductAnalytics-filters">

            <Input
              prefix={<SearchOutlined />}
              placeholder="Search company..."
              value={searchText}
              onChange={(e) =>
                setSearchText(e.target.value)
              }
              allowClear
              className="qhrProductAnalytics-search"
            />

            {selectedProduct !== "ALL" && (
              <>
                <Select
                  value={statusFilter}
                  onChange={setStatusFilter}
                  className="qhrProductAnalytics-select"
                  options={[
                    {
                      value: "ALL",
                      label: "All Status",
                    },
                    {
                      value: "ACTIVE",
                      label: "Active",
                    },
                    {
                      value: "TRIAL",
                      label: "Trial",
                    },
                    {
                      value: "INACTIVE",
                      label: "Inactive",
                    },
                    {
                      value: "EXPIRED",
                      label: "Expired",
                    },
                  ]}
                />

                <Select
                  value={planFilter}
                  onChange={setPlanFilter}
                  className="qhrProductAnalytics-select"
                  options={[
                    {
                      value: "ALL",
                      label: "All Plans",
                    },
                    {
                      value: "Starter",
                      label: "Starter",
                    },
                    {
                      value: "Growth",
                      label: "Growth",
                    },
                    {
                      value: "Business",
                      label: "Business",
                    },
                  ]}
                />
              </>
            )}

          </div>

        </div>

        {/* =================================================
            TABLE
        ================================================== */}

        <div className="qhrProductAnalytics-table-wrapper">

          <table className="qhrProductAnalytics-table">

            <thead>

              <tr>

                <th>Sr.</th>

                <th>Company</th>

                {selectedProduct === "ALL" && (
                  <>
                    <th>QHRFlow Plan</th>
                    <th>NuJobs Plan</th>
                  </>
                )}

                {selectedProduct !== "ALL" && (
                  <th>Plan</th>
                )}

                <th>Users</th>

                <th>Jobs</th>

                {selectedProduct === "QHRFLOW" && (
                  <th>Resumes</th>
                )}

                <th>Applications</th>

                <th>Revenue</th>

                {selectedProduct !== "ALL" && (
                  <th>Status</th>
                )}

                <th>Analytics</th>

              </tr>

            </thead>

            <tbody>

              {filteredCompanies?.map(
                (company, index) => {

                  const subscription =
                    selectedProduct !== "ALL"
                      ? company.subscriptions[
                          selectedProduct
                        ]
                      : null;

                  let users = company.users;

                  let jobs = 0;

                  let applications = 0;

                  let revenue =
                    getCompanyRevenue(company);

                  if (
                    selectedProduct !== "ALL"
                  ) {
                    users =
                      subscription?.users || 0;

                    jobs =
                      subscription?.jobs || 0;

                    applications =
                      subscription?.applications || 0;

                    revenue =
                      subscription?.revenue || 0;
                  } else {
                    jobs =
                      (company.subscriptions.QHRFLOW
                        ?.jobs || 0) +
                      (company.subscriptions.NUJOBS
                        ?.jobs || 0);

                    applications =
                      (company.subscriptions.QHRFLOW
                        ?.applications || 0) +
                      (company.subscriptions.NUJOBS
                        ?.applications || 0);
                  }

                  return (
                    <tr key={company.qhoid}>

                      <td>
                        {index + 1}
                      </td>

                      <td>

                        <div className="qhrProductAnalytics-company-name">
                          {company.companyName}
                        </div>

                        <div className="qhrProductAnalytics-company-info">
                          {company.qhoid}
                        </div>

                        <div className="qhrProductAnalytics-company-info">
                          {company.city},{" "}
                          {company.country}
                        </div>

                      </td>

                      {/* ALL PRODUCTS */}

                      {selectedProduct ===
                        "ALL" && (
                        <>
                          <td>
                            <ProductPlan
                              product="QHRFLOW"
                              subscription={
                                company
                                  .subscriptions
                                  .QHRFLOW
                              }
                            />
                          </td>

                          <td>
                            <ProductPlan
                              product="NUJOBS"
                              subscription={
                                company
                                  .subscriptions
                                  .NUJOBS
                              }
                            />
                          </td>
                        </>
                      )}

                      {/* SINGLE PRODUCT */}

                      {selectedProduct !==
                        "ALL" && (
                        <td>
                          <span className="qhrProductAnalytics-plan-badge">
                            {
                              subscription?.planName
                            }
                          </span>
                        </td>
                      )}

                      <td>
                        {formatNumber(users)}
                      </td>

                      <td>
                        {formatNumber(jobs)}
                      </td>

                      {selectedProduct ===
                        "QHRFLOW" && (
                        <td>
                          {formatNumber(
                            subscription?.resumes
                          )}
                        </td>
                      )}

                      <td>
                        {formatNumber(
                          applications
                        )}
                      </td>

                      <td className="qhrProductAnalytics-revenue-cell">
                        {formatCurrency(revenue)}
                      </td>

                      {selectedProduct !==
                        "ALL" && (
                        <td>

                          <span
                            className={`qhrProductAnalytics-status ${getStatusClass(
                              subscription?.status
                            )}`}
                          >
                            {
                              subscription?.status
                            }
                          </span>

                        </td>
                      )}

                      <td>

                        <button
                          className="qhrProductAnalytics-view-button"
                          onClick={() =>
                            handleViewAnalytics(
                              company
                            )
                          }
                        >
                          <EyeOutlined />

                          View
                        </button>

                      </td>

                    </tr>
                  );
                }
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}